import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useLegacyMode } from '@/entities/legacy-mode';
import { LegacyOrderCreatePage } from '@/pages/legacy-order-create';
import { requireAuth } from '../require-auth';

/**
 * Order creation — LEGACY ONLY.
 *
 * The new Delivery UI has no create screen yet, so unlike the other delivery
 * routes this one does not branch: with legacy mode off it redirects back to
 * the orders list rather than rendering the legacy screen to someone who never
 * opted into it.
 *
 * The `orders_` prefix opts out of nesting under `/delivery/orders` — this is
 * a full-page form, not a panel inside the list.
 */
export const Route = createFileRoute('/delivery/orders_/create')({
  beforeLoad: requireAuth,
  component: DeliveryOrderCreateRoute,
});

function DeliveryOrderCreateRoute() {
  const legacy = useLegacyMode();
  if (!legacy) return <Navigate to="/delivery/orders" />;
  return <LegacyOrderCreatePage />;
}
